<template>
<div class="panel-wrapper">
  <!-- header -->
  <el-row class="title-bar" type="flex" justify="space-between">
    <div>
      <h3 v-if="displayTitle !== null">{{displayTitle}}</h3>
      <slot name="header-tool-left" />
    </div>
    <div>
      <slot name="header-tool-right" />
    </div>
  </el-row>
  <!-- body-->
  <el-row class="panel-body">
    <slot name="body" />
  </el-row>
</div>
</template>

<script>
import {
  isEmpty
} from '@/utils/basic';

export default {
  name: 'WPanel',
  props: {
    title: {
      type: String,
    },
  },
  computed: {
    displayTitle() {
      return isEmpty(this.title) ? null : this.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-wrapper {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/box/Panel/Panel.vue